import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import IntegrationImage from "../../../../integrations/components/IntegrationImage";
import TextIntegrationStyle from "../../TextIntegrationStyle";
import {
  getServerCreationDateRows,
  getServerLastLaunchDateRows,
  getServerLastModifiedDateRows,
  getServerLastScanDateRows,
  getServerLastSeenRows,
  getServerLastUpdatedDateRows,
  getServerPurchaseDateRows,
} from "./checkRowsServerData";

const ServerHistoryView = ({ entityData }) => {
  const [firstSeenRows, setFirstSeenRows] = useState([]);
  const [lastSeenRows, setLastSeenRows] = useState([]);
  const [lastLaunchRows, setLastLaunchRows] = useState([]);
  const [lastModifiedRows, setLastModifiedRows] = useState([]);
  const [lastScanRows, setLastScanRows] = useState([]);
  const [lastUpdatedRows, setLastUpdatedRows] = useState([]);
  const [purchaseDateRows, setPurchaseDateRows] = useState([]);
  useEffect(() => {
    setLastSeenRows(getServerLastSeenRows(entityData));
    setFirstSeenRows(getServerCreationDateRows(entityData));
    setLastLaunchRows(getServerLastLaunchDateRows(entityData));
    setLastModifiedRows(getServerLastModifiedDateRows(entityData));
    setLastScanRows(getServerLastScanDateRows(entityData));
    setLastUpdatedRows(getServerLastUpdatedDateRows(entityData));
    setPurchaseDateRows(getServerPurchaseDateRows(entityData));
  }, [entityData]);

  return (
    (lastSeenRows.length > 0 ||
      firstSeenRows.length > 0 ||
      lastLaunchRows.length > 0 ||
      lastModifiedRows.length > 0 ||
      lastScanRows.length > 0 ||
      lastUpdatedRows.length > 0 ||
      purchaseDateRows.length > 0) && (
      <Box display={"flex"} flexDirection={"column"} gap={2}>
        {/* Last seen */}
        {lastSeenRows.length > 0 && (
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            <Box display={"flex"} gap={1} alignItems={"center"}>
              <Typography variant="subtitle2">Last Seen</Typography>
            </Box>
            <Box display={"flex"} gap={1} flexDirection={"column"} ml={3}>
              {lastSeenRows.map((row) => (
                <TextIntegrationStyle
                  key={row.id}
                  title={
                    <Box
                      display={"flex"}
                      alignItems={"center"}
                      flexDirection={"row"}
                    >
                      <IntegrationImage
                        name={row.source}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={row.last_seen}
                ></TextIntegrationStyle>
              ))}
            </Box>
          </Box>
        )}
        {/* Creation date */}
        {firstSeenRows.length > 0 && (
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            <Box display={"flex"} gap={1} alignItems={"center"}>
              <Typography variant="subtitle2">Creation Date</Typography>
            </Box>
            <Box display={"flex"} gap={1} flexDirection={"column"} ml={3}>
              {firstSeenRows.map((row) => (
                <TextIntegrationStyle
                  key={row.id}
                  title={
                    <Box
                      display={"flex"}
                      alignItems={"center"}
                      flexDirection={"row"}
                    >
                      <IntegrationImage
                        name={row.source}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={row.creation_date}
                ></TextIntegrationStyle>
              ))}
            </Box>
          </Box>
        )}
        {/* Last modified */}
        {lastModifiedRows.length > 0 && (
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            <Box display={"flex"} gap={1} alignItems={"center"}>
              <Typography variant="subtitle2">Last Modified Time</Typography>
            </Box>
            <Box display={"flex"} gap={1} flexDirection={"column"} ml={3}>
              {lastModifiedRows.map((row) => (
                <TextIntegrationStyle
                  key={row.id}
                  title={
                    <Box
                      display={"flex"}
                      alignItems={"center"}
                      flexDirection={"row"}
                    >
                      <IntegrationImage
                        name={row.source}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={row.last_modified}
                ></TextIntegrationStyle>
              ))}
            </Box>
          </Box>
        )}
        {/* Last launch */}
        {lastLaunchRows.length > 0 && (
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            <Box display={"flex"} gap={1} alignItems={"center"}>
              <Typography variant="subtitle2">Last Launch Time</Typography>
            </Box>
            <Box display={"flex"} gap={1} flexDirection={"column"} ml={3}>
              {lastLaunchRows.map((row) => (
                <TextIntegrationStyle
                  key={row.id}
                  title={
                    <Box
                      display={"flex"}
                      alignItems={"center"}
                      flexDirection={"row"}
                    >
                      <IntegrationImage
                        name={row.source}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={row.last_launch}
                ></TextIntegrationStyle>
              ))}
            </Box>
          </Box>
        )}
        {lastScanRows.length > 0 && (
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            <Box display={"flex"} gap={1} alignItems={"center"}>
              <Typography variant={"subtitle2"}>Last Scan Date</Typography>
            </Box>
            <Box display={"flex"} gap={1} flexDirection={"column"} ml={3}>
              {lastScanRows.map((row) => (
                <TextIntegrationStyle
                  key={row.id}
                  title={
                    <Box
                      display={"flex"}
                      alignItems={"center"}
                      flexDirection={"row"}
                    >
                      <IntegrationImage
                        name={row.source}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={row.last_scan_date}
                ></TextIntegrationStyle>
              ))}
            </Box>
          </Box>
        )}
        {lastUpdatedRows.length > 0 && (
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            <Box display={"flex"} gap={1} alignItems={"center"}>
              <Typography variant={"subtitle2"}>Last Updated </Typography>
            </Box>
            <Box display={"flex"} gap={1} flexDirection={"column"} ml={3}>
              {lastUpdatedRows.map((row) => (
                <TextIntegrationStyle
                  key={row.id}
                  title={
                    <Box
                      display={"flex"}
                      alignItems={"center"}
                      flexDirection={"row"}
                    >
                      <IntegrationImage
                        name={row.source}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={row.last_updated}
                ></TextIntegrationStyle>
              ))}
            </Box>
          </Box>
        )}
        {purchaseDateRows.length > 0 && (
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            <Box display={"flex"} gap={1} alignItems={"center"}>
              <Typography variant={"subtitle2"}>Purchase Date </Typography>
            </Box>
            <Box display={"flex"} gap={1} flexDirection={"column"} ml={3}>
              {purchaseDateRows.map((row) => (
                <TextIntegrationStyle
                  key={row.id}
                  title={
                    <Box
                      display={"flex"}
                      alignItems={"center"}
                      flexDirection={"row"}
                    >
                      <IntegrationImage
                        name={row.source}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={row.purchase_date}
                ></TextIntegrationStyle>
              ))}
            </Box>
          </Box>
        )}
      </Box>
    )
  );
};

export default ServerHistoryView;
